import React, {Component} from 'react';
import {getGameTitle} from '../../../../../helpers/eventHelpers';
import {getText} from '../../../../../helpers/localization';
import OpenBet from '../../../components/openBet';
import {translateAFUnderOverLanguageBased} from "../../americanFootball/helpers/marketHelpers";

class OpenBetAmericanFootball extends Component {

    render() {
        let awayTeam = getText(this.props.betSelection.bets[0].event.teamTwo, this.props.store);
        let homeTeam = getText(this.props.betSelection.bets[0].event.teamOne, this.props.store);

        let name;

        if (this.props.betSelection.bets[0].market.selection.toLowerCase().indexOf('home') === 0) {
            name = this.props.betSelection.bets[0].market.selection.replace(/Home/ig, homeTeam);
            name = translateAFUnderOverLanguageBased(name, this.props.store);
        } else if (this.props.betSelection.bets[0].market.selection.toLowerCase().indexOf('away') === 0) {
            name = this.props.betSelection.bets[0].market.selection.replace(/Away/ig, awayTeam);
            name = translateAFUnderOverLanguageBased(name, this.props.store);
        } else if (this.props.betSelection.bets[0].market.selection.toLowerCase().indexOf('under') === 0) {
            let number = this.props.betSelection.bets[0].market.selection.replace(/Under /ig, '');
            name = getText('Under', this.props.store, [number])
        } else if (this.props.betSelection.bets[0].market.selection.toLowerCase().indexOf('over') === 0) {
            let number = this.props.betSelection.bets[0].market.selection.replace(/Over /ig, '');
            name = getText('Over', this.props.store, [number])
        } else if (isNaN(this.props.betSelection.bets[0].market.selection)) {
            name = getText(this.props.betSelection.bets[0].market.selection, this.props.store);
        } else {
            name = this.props.betSelection.bets[0].market.selection;
        }

        if (name.toLowerCase().indexOf(' and ') > 0) {
            let andText = ' ' + getText('and', this.props.store) + ' '
            name = name.replace(/ And /ig, andText);
        }
        let names = [name];


        let title = `${awayTeam} ${getText('AT', this.props.store)} ${homeTeam}`;
        let eventName = getGameTitle(title, this.props.betSelection.bets[0].event.eventTimeDate, this.props.store.getState().vpp.systemLanguage);
        let betType = getText(this.props.betSelection.bets[0].betType.name, this.props.store, [homeTeam, awayTeam]);
        let odd = this.props.betSelection.bets[0].market.odds;

        return (
            <OpenBet
                store={this.props.store}
                index={this.props.index}
                betSelection={this.props.betSelection}
                names={names}
                betType={betType}
                odd={odd}
                eventName={eventName}
                isEnabled={this.props.isEnabled}
                openBetFocusCallback={this.props.openBetFocusCallback}/>
        );
    }
}

export default OpenBetAmericanFootball;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/americanFootball/components/openBetAmericanFootball.js